import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appTwoDigitDecimaNumber]'
})
export class TwoDigitDecimaNumberDirective {
  // Input to specify the number of decimal places
  @Input('appTwoDigitDecimaNumber') decimalPlaces: number = 2;

  // Allow key codes for special events like Backspace, Arrow keys, etc.
  private specialKeys: Array<string> = [
    'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Del'
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const inputElement = this.el.nativeElement;

    // Allow special keys and Ctrl + A
    if (
      this.specialKeys.includes(event.key) ||
      (event.key.toLowerCase() === 'a' && (event.ctrlKey || event.metaKey))
    ) {
      return;
    }

    const currentValue: string = inputElement.value;
    const position = inputElement.selectionStart || 0;

    // Predict the next value after the key press
    const nextValue: string = [
      currentValue.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      currentValue.slice(inputElement.selectionEnd || currentValue.length)
    ].join('');

    // Construct dynamic regex based on the specified decimal places
    const regex = new RegExp(`^\\d*\\.?\\d{0,${this.decimalPlaces}}$`);

    // Prevent input if it does not match the regex
    if (nextValue && !regex.test(nextValue)) {
      event.preventDefault();
    }
  }
}
